import styled, { css } from 'styled-components'

export const Container = styled.div`
  @media only screen and (min-width: ${props => props.theme.screen_lg_min}) {
    padding-left: 18px;
    margin-left: 12px;
    flex: 1;
    overflow-x: hidden;
  }
`

export const PlpSeoText = styled.div`
  margin-bottom: 25px;
`

export const SearchContent = styled.div`
  ${props =>
    props.withBreadcrumb &&
    css`
      @media only screen and (min-width: ${props.theme.screen_md_min}) {
        padding-top: 10px;
      }
    `}
`
